import React from 'react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import ConventionPaymentShare from '../ConventionPaymentShare';
import { PauseCircle, PlayCircle, Ban } from 'lucide-react';
import { toast } from 'sonner';

export default function ModalsActions({
  openActionModal, setOpenActionModal,
  openActionMasseModal, setOpenActionMasseModal,
  openPaymentShareModal, setOpenPaymentShareModal,
  selectedConvention,
  actionData, setActionData,
  actionMasseData, setActionMasseData,
  selectedConventions,
  handleAction,
  handleActionMasse,
  resetActionMasseData,
  fetchData,
  getAuthHeader,
}) {
  return (
    <>
      {/* Modal Action (Suspendre/Réactiver/Résilier) */}
      <Dialog open={openActionModal} onOpenChange={setOpenActionModal}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              {actionData.action === 'suspendre' && '⏸️ Suspendre le convention'}
              {actionData.action === 'reactiver' && '▶️ Réactiver le convention'}
              {actionData.action === 'resilier' && '🚫 Résilier le convention'}
            </DialogTitle>
          </DialogHeader>

          {selectedConvention && (
            <div className="space-y-4 py-4">
              <div className="bg-slate-50 p-3 rounded">
                <p className="font-semibold">{selectedConvention.titre}</p>
                <p className="text-sm text-slate-600">{selectedConvention.destinataire_nom}</p>
              </div>

              <div>
                <Label>Raison *</Label>
                <Textarea
                  value={actionData.raison}
                  onChange={(e) => setActionData({...actionData, raison: e.target.value})}
                  rows={4}
                  placeholder="Indiquez la raison de cette action..."
                  className="mt-2"
                />
              </div>
            </div>
          )}

          <DialogFooter>
            <Button variant="outline" onClick={() => setOpenActionModal(false)}>
              Annuler
            </Button>
            <Button
              onClick={handleAction}
              className={
                actionData.action === 'reactiver' ? 'bg-green-600 hover:bg-green-700' : ''
              }
              variant={actionData.action !== 'reactiver' ? 'destructive' : 'default'}
            >
              {actionData.action === 'suspendre' && <><PauseCircle className="h-4 w-4 mr-2" />Suspendre</>}
              {actionData.action === 'reactiver' && <><PlayCircle className="h-4 w-4 mr-2" />Réactiver</>}
              {actionData.action === 'resilier' && <><Ban className="h-4 w-4 mr-2" />Résilier</>}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal Actions en Masse */}
      <Dialog open={openActionMasseModal} onOpenChange={setOpenActionMasseModal}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              {actionMasseData.action === 'archiver' && '📦 Archiver les conventions sélectionnés'}
              {actionMasseData.action === 'supprimer' && '🗑️ Supprimer les conventions sélectionnés'}
              {actionMasseData.action === 'suspendre' && '⏸️ Suspendre les conventions sélectionnés'}
              {actionMasseData.action === 'reactiver' && '▶️ Réactiver les conventions sélectionnés'}
              {actionMasseData.action === 'resilier' && '🚫 Résilier les conventions sélectionnés'}
            </DialogTitle>
          </DialogHeader>

          <div className="space-y-4 py-4">
            <div className="bg-blue-50 p-3 rounded">
              <p className="font-semibold text-blue-900">
                {selectedConventions.length} convention(s) sélectionné(s)
              </p>
              <p className="text-sm text-blue-700 mt-1">
                {actionMasseData.action === 'supprimer' &&
                  '⚠️ Attention : Seuls les brouillons seront supprimés'}
                {actionMasseData.action === 'suspendre' &&
                  '⚠️ Seuls les conventions actifs seront suspendus'}
                {actionMasseData.action === 'reactiver' &&
                  '⚠️ Seuls les conventions suspendus seront réactivés'}
                {actionMasseData.action === 'resilier' &&
                  '⚠️ Seuls les conventions actifs ou suspendus seront résiliés'}
                {actionMasseData.action === 'archiver' &&
                  '⚠️ Les brouillons ne seront pas archivés'}
              </p>
            </div>

            {['suspendre', 'resilier', 'archiver', 'reactiver'].includes(actionMasseData.action) && (
              <div>
                <Label>Raison {['suspendre', 'resilier', 'archiver'].includes(actionMasseData.action) && '*'}</Label>
                <Textarea
                  value={actionMasseData.raison}
                  onChange={(e) => setActionMasseData({...actionMasseData, raison: e.target.value})}
                  rows={4}
                  placeholder="Indiquez la raison de cette action..."
                  className="mt-2"
                />
              </div>
            )}
          </div>

          <DialogFooter>
            <Button
              variant="outline"
              onClick={() => {
                setOpenActionMasseModal(false);
                resetActionMasseData();
              }}
            >
              Annuler
            </Button>
            <Button
              onClick={handleActionMasse}
              className={
                actionMasseData.action === 'reactiver' ? 'bg-green-600 hover:bg-green-700' : ''
              }
              variant={actionMasseData.action === 'supprimer' ? 'destructive' : 'default'}
            >
              {actionMasseData.action === 'archiver' && <>📦 Archiver</>}
              {actionMasseData.action === 'supprimer' && <>🗑️ Supprimer</>}
              {actionMasseData.action === 'suspendre' && <>⏸️ Suspendre</>}
              {actionMasseData.action === 'reactiver' && <>▶️ Réactiver</>}
              {actionMasseData.action === 'resilier' && <>🚫 Résilier</>}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal Paiement et Partage */}
      <ConventionPaymentShare
        convention={selectedConvention}
        getAuthHeader={getAuthHeader}
        open={openPaymentShareModal}
        onOpenChange={setOpenPaymentShareModal}
        onSuccess={() => {
          fetchData();
          toast.success('Action effectuée avec succès');
        }}
      />
    </>
  );
}
